import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const countriesAdapter = createEntityAdapter({
    selectId: x => x.Id
})

const initialState = countriesAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchCountries = createAsyncThunk('countries/Get', async () => {
    const response = await client.get('/Countries')
    return response.data
})

const countriesSlice = createSlice({
    name: 'countries',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchCountries.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchCountries.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            countriesAdapter.addMany(state, action.payload)
        },
        [fetchCountries.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default countriesSlice.reducer

export const {
    selectAll: selectAllCountries,
    selectById: selectCountriesById,
} = countriesAdapter.getSelectors((state) => state.countries)
